import React, { type FC } from 'react';

import { Input } from './input';

interface DateInputProps {
  value?: Date;
  onChange: (date: Date) => void;
  placeholder?: string;
  disabled?: boolean;
}

export const DateInput: FC<DateInputProps> = ({
  value,
  onChange,
  placeholder = 'Select date',
  disabled = false,
}) => {
  const formatDateForInput = (date?: Date): string => {
    if (!date) return '';
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    if (inputValue) {
      const [year, month, day] = inputValue.split('-').map(Number);
      const newDate = new Date(year, month - 1, day);
      if (!isNaN(newDate.getTime())) {
        onChange(newDate);
      }
    }
  };

  return (
    <Input
      type="date"
      value={formatDateForInput(value)}
      onChange={handleInputChange}
      placeholder={placeholder}
      disabled={disabled}
      className="w-[120px]"
    />
  );
};
